var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-ws",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h512v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00006b",
    d: "M0-1h256v128H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.524 116.574l-10.151-6.852-9.73 6.966 3.09-12.22-9.34-7.53 12.064-.7 3.959-11.622 4.362 11.788 11.787.347-9.366 7.987zm-1.738-81.281l-8.122-5.219-7.975 5.18 2.214-9.732-7.15-6.365 9.494-.795 3.548-9.113 3.656 9.24 9.347.733-7.237 6.506zM94.892 64.541l-7.904-5.423-8.08 5.422 2.516-9.504-7.447-6.325 9.45-.451 3.479-9.331 3.332 9.225 9.592.559-7.393 6.153zm71.964-6.535l-7.585-4.892-7.38 4.952 2.124-9.024-6.799-5.777 8.896-.685 3.175-8.524 3.373 8.602 8.764.509-6.809 6zm-21.212 21.372l-5.056-3.15-5.04 3.181 1.314-5.982-4.464-4.01 5.87-.547 2.283-5.659 2.313 5.644 5.873.512-4.44 4.035z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWs);
export default __webpack_public_path__ + "static/media/ws.55ccdcf08b0ef3c4d4fc6b8a44fcc5b2.svg";
export { ForwardRef as ReactComponent };